<template>
  <div
    id="home"
    v-loading="loading"
    :element-loading-text="loadingMsg"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    @click="closeNav"
    @wheel="scrollHandler"
  >
    <div>
      <div
        class="header fixed   left-0 right-0 m-auto  "
        :style="headStyle"
      > 
        <router-link  to="/home">
          <img v-show="srcs == 1" src="@/assets/home/logowhite.png" class="mr-10" alt="" />
        <img v-show="srcs == 2" src="@/assets/home/logocolor.png" class="mr-10" alt="" />
        </router-link>
        <div class="logo" @click="toHome">
          <!-- <img src="../assets/logo.png" alt="" /> -->
        </div>
        <el-menu
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          :default-active="$route.path"
          text-color="#909399"
          active-text-color="#2b9868"
        >
          <template v-for="(item, index) in routerList">
            <el-menu-item
              :index="item.path"
              :key="index"
              v-if="!item.children"
              @click="routerShop(item.label)"
            >
              {{ $t(item.label) }}</el-menu-item
            >

            <el-submenu :index="item.path + ''" :key="index" v-else>
              <template slot="title">{{ $t(item.label) }}</template>

              <template v-for="(citem, cindex) in item.children">
                <el-menu-item
                  @click="routeClick(citem.label)"
                  :index="citem.path"
                  :key="cindex"
                  v-if="!citem.children"
                  >{{ $t(citem.label) }}</el-menu-item
                >
                <el-submenu :index="citem.path" :key="cindex" v-else>
                  <template slot="title">{{ citem.label }}</template>

                  <template v-for="(scitem, scindex) in citem.children">
                    <el-menu-item :index="scitem.path" :key="scindex">{{
                      scitem.label
                    }}</el-menu-item>
                  </template>
                </el-submenu>
              </template>
            </el-submenu>
          </template>
        </el-menu>
      </div>
   
    </div>
    <!-- 其他页 -->
    <div>
      <router-view></router-view>
    </div>
    <bottom-info></bottom-info>
  </div>
</template>

<script>
import BottomInfo from "@/components/bottomInfo";
import { getUserEmail } from "@/api";
import routerList from "@/utils/routerList";
import $ from "jquery";
export default {
  name: "home",
  components: {
    BottomInfo,
  },
  data() {
    return {
      // activeIndex: "",
      headStyle: {
        //导航栏样式
        background: "",
        boxShadow:""
      },
      srcs: 1,

      navs: [
        "HOME",
        // 'MINE',
        // 'IOT INDUSTRY ELITE',
        // 'LPWAN BASE STATION',
        "PRODUCT",
        "COMPARE",
        // 'FAQ',
      ],
      scrollIndex: 0,
      scrollTime: 0,
      verticalPagesStyle: {
        top: "0",
      },

      grow: false,
      cookie: "",
      touchStartY: "",
      touchEndY: "",
      navShow: true,
      email: "",
      loading: false,
      loadingMsg: "",
      routerList,
      url: "",
      indexro: "https://greenpalmiot.com/",
      discord: "https://discord.gg/huXkQbkJDW",
      twitter: "https://twitter.com/GreenPalmIoT",
      shopUrl: "https://greenpalmiot.com/",
      show:false,
      electricEquipment:"https://greenpalmiot.com/collections/smart-meter",
    };
  },
  created() {
  },
  mounted() {
 
    window.addEventListener("scroll", this.handleScroll); //监听页面滚动
    // 获取登录状态
    this.cookie = this.$cookie.get("Authorization");

    // if (this.$route.name === "login") return;
    // this.$store.dispatch("changeHomeDataAsync");

    // 获取屏幕宽度
    const windowWidth = document.documentElement.clientWidth;
    if (windowWidth < 768) {
      this.navShow = false;
    }

    // 获取用户邮箱
    if (this.cookie) {
      getUserEmail().then((res) => {
        if (res.status == 200) {
          this.email = res.data;
        }
      });
    }
  },
  methods: {
    imgHome(){
      
    },
    // 二级菜单
    routeClick(e) {
      console.log(e);
      if (e == "navbar.ioTHardware") {
        window.open(this.indexro, "_blank");
      } else if (e == "navbar.discord") {
        window.open(this.discord, "_blank");
      } else if (e == "navbar.twitter") {
        window.open(this.twitter, "_blank");
      }else if(e == "navbar.electricEquipment"){
        window.open(this.electricEquipment, "_blank");
      }
    },
    // 一级菜单
    routerShop(url) {
      console.log(url);
    sessionStorage.setItem("key",url);
    let dataUrl = sessionStorage.getItem('key');
    console.log(dataUrl);
      if (url == "navbar.shop") {
        window.open(this.shopUrl, "_blank");
      }
      if (url == "navbar.lang" && this.lang == "zh") {
        this.lang = "en";
        this.$i18n.locale = this.lang;
      } else if (url == "navbar.lang") {
        this.lang = "zh";
        this.$i18n.locale = this.lang;
      }
    },
    // 页面移动导航栏改变颜色
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      //设置背景颜色的透明度
      if (scrollTop > 400) {
        
        this.headStyle.background = "#FFF";
         this.headStyle.boxShadow = "0 15px 10px -15px rgba(0, 0, 0, 0.3)";
        console.log( this.headStyle.boxShadow);
        this.srcs = 2;
      } else if (scrollTop == 0 || scrollTop < 400) {
        this.headStyle.background = "transparent";
        this.headStyle.boxShadow = ""
        this.srcs = 1;
      }
    },

    beforeDestroy() {
      window.removeEventListener("scroll", this.handleScroll);
    },
    toNews() {
      // 登录状态下，才能跳转
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = "https://blog.piscesiot.com/";
      // 跳转到新窗口
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      // if (this.logged) {
      //   let link = document.createElement("a");
      //   link.style.display = "none";
      //   link.href = "https://blog.piscesiot.com/";
      //   // 跳转到新窗口
      //   link.target = "_blank";
      //   document.body.appendChild(link);
      //   link.click();
      //   document.body.removeChild(link);
      // } else {
      //   Message.error('Please login first');
      //   this.$router.push({name: 'login'});
      // }
    },
    toHome() {
      this.$router.push({ name: "home" });
      this.$nextTick(() => {
        $(".floors").scrollTop(0);
      });
    },
    changeNavShow() {
      this.navShow = !this.navShow;
    },
    closeNav() {
      const windowWidth = document.documentElement.clientWidth;
      if (windowWidth <= 768) {
        this.navShow = false;
      }
    },
    touchMove(e) {
      let moveY = e.touches[0].clientY;
      // console.log(moveY);
    },
    touchStart(e) {
      this.touchStartY = e.touches[0].clientY;
    },
    touchEnd(e) {
      this.touchEndY = e.changedTouches[0].clientY;
      this.mouseScroll({
        wheelDelta: this.touchEndY - this.touchStartY,
      });
    },
    join() {
      // this.jumpFloor(3);
    },
    mouseScroll(e) {
      // 商品列表不滚动
      if (!this.mouseScrollStatus) return;
      // 防止连跳多页
      // let nowTime = Date.now();
      // if (nowTime - this.scrollTime < 1000) return;
      // this.scrollTime = nowTime;

      let wheel;
      if ("wheelDelta" in e) {
        wheel = e.wheelDelta;
      } else {
        wheel = e.deltaY * -1;
      }
      if (this.scrollIndex >= 0) {
        if (wheel < 0 && this.scrollIndex < 4) {
          ++this.scrollIndex;
        } else if (wheel > 0 && this.scrollIndex > 0) {
          --this.scrollIndex;
        }
        this.verticalPagesStyle.top = `-${this.scrollIndex}00%`;
      }
    },
    scrollHandler() {
      const h = document.documentElement.clientHeight;
      const top = $(".floors").scrollTop();
      this.scrollIndex = parseInt(top / h);
    },
    jumpFloor(i) {
      if (this.$route.name !== "home") {
        this.$router.push({ name: "home" });
      }
      // this.scrollIndex = i;
      // this.verticalPagesStyle.top = `-${this.scrollIndex}00%`;

      const h = document.documentElement.clientHeight;
      this.$nextTick(() => {
        $(".floors").scrollTop(i * h);
      });
    },

    commandHandle(name) {
      if (name === "login") {
        this.$store.dispatch("logoutAsync");
      } else {
        this.$router.push({ name: "user" });
      }
    },
    handleSelect(key) {
      this.$router.push(key);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
#home {
  .header {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    z-index: 10;
    .logo {
      display: flex;
      align-items: center;
      cursor: pointer;
      img {
        width: 22vh;
      }
      h1 {
        font-size: 2.55vh;
      }
    }
    .nav-icon {
      display: none;
    }
  }
  
  .floors {
    overflow-y: auto;
    overflow-x: hidden;
    // position: absolute;
    // left: 0;
    width: 100vw;
    height: 100vh;
  }
  ul,
  li {
    list-style: none !important;
    color: #909399;
    background-color: transparent !important;
    
  }
  
}
.el-menu{
  background-color: transparent !important;
}

.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 2px solid #79c06b;
  color: green;
  background-color: transparent !important;
  // background: none;
}
.el-menu.el-menu--horizontal {
  border-bottom: none;
}
.el-menu-item:not(.is-disabled):hover {
  color: green !important;
   background-color: transparent !important;
}
</style>



// WEBPACK FOOTER //
// src/views/layout.vue